import router from '@/router'
/**
 * ErrorManager is a utility class that handles errors in the application.
 * It provides methods to handle specific error cases, such as authentication errors
 */
export class ErrorManager {
  constructor() {}

  static handleError(error: any) {
    const errorCode = error.response?.data?.code

    if (['auth/session-expired', 'user/sessionExpired'].includes(errorCode)) {
      return
    }

    //If the error code is related to auth token expirtation, redirect to login page
    if (['auth/no-token', 'auth/auth-error'].includes(errorCode))
      router.push('/login')

    //When a request approver is not found, redirect to the request approver page
    if (
      errorCode ===
      'approval-flow/approval-flow-request/approva-flow-request-not-found'
    )
      router.push('/requestApprover')

    return
  }
}
